import styles from './ApplicationMainContainer.module.css'
import { Toolbar } from '@mui/material'
import { ReactNode } from 'react'

interface ApplicationMainContainerProps {
    children?: ReactNode;
}

export const ApplicationMainContainer = (props: ApplicationMainContainerProps): JSX.Element => {
    const {
        children
    } = props

    return (
        <div className={styles.ApplicationMainContainer__Root}>
            <Toolbar className={styles.ApplicationMainContainer__ToolbarSeparator} sx={{height: '84px', displayPrint: 'none' }} />
            { children }
        </div>
    )
}